module.exports = __webpack_public_path__ + "static/img/brand-second-1.f3afd6d5.png";